import { Button, Checkbox, Space } from "antd";
import { useState } from "react";
import AleartYellowIcon from "../../assets/icons/AleartYellowIcon";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

type Props = {
  handleSubmit?: () => void;
  isLoading?: boolean;
  confirmMessage?: string;
} & ModalComponentProps<string>;

export default function SubmitConfirmModal({
  handleClose,
  handleSubmit,
  isLoading,
  confirmMessage,
  ...rest
}: Props) {
  const [agree, setAgree] = useState(false);

  return (
    <>
      <CustomModal
        title=""
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        <div className="flex items-center justify-start gap-2">
          <AleartYellowIcon />
          <div className="text-zinc-700 text-xl font-semibold">
            Are you sure?
          </div>
        </div>

        <div className="w-full  mt-[20px]">
          <Checkbox
            className="!select-none !font-medium"
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
          >
            {confirmMessage ||
              "Do you want to submit this to the Line Manager?"}
          </Checkbox>
        </div>

        <Space className="w-full mt-6" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
            htmlType="button"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            disabled={!agree}
            onClick={handleSubmit}
            loading={isLoading}
          >
            Yes! Submit
          </Button>
        </Space>
      </CustomModal>
    </>
  );
}
